import React, { useEffect, useState } from 'react';
import FilterDropdown from './Filter/components/FilterDropdown';
import { translate } from '../services/translate';
import { polygonService } from '../services/central-api/polygons';
import { DropDownDirectionType } from 'react-native-dropdown-picker';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
    setPolygons: React.Dispatch<React.SetStateAction<MapPolygon[]>>;
    setPolygonType?: React.Dispatch<React.SetStateAction<string | null>>;
    dropDownDirection?: DropDownDirectionType;
    zIndex: number;
    label?: string;
    showTooltip?: boolean;
    tooltipText?: string;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    setPendingLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function MapPolygonDropdown({ setPolygons, setPolygonType, dropDownDirection, zIndex, label, showTooltip, tooltipText, labelStyle, viewStyle, setPendingLoading }: Props) {

    const [selectedPolygonsType, setSelectedPolygonsType] = useState<string | null>(null);
    const [polygonsType, setPolygonsType] = useState<{ type: string; }[]>([]);

    async function getPolygonsType() {
        try {
            const polygonsType = await polygonService.getPolygonsType();
            setPolygonsType(polygonsType);
        } catch (err) {
            console.error(err);
        }
    }

    async function getPolygonsByType(type: string) {
        try {
            setPendingLoading?.(true);
            const polygons = await polygonService.getPolygonsByType(type);
            setPolygons(polygons);
        } catch (err) {
            console.error(err);
        } finally {
            setPendingLoading?.(false);
        }
    }

    useEffect(() => {
        if (setPolygonType) {
            setPolygonType(selectedPolygonsType);
        }

        if (selectedPolygonsType) {
            getPolygonsByType(selectedPolygonsType);
        } else {
            setPolygons([]);
        }
    }, [selectedPolygonsType]);

    useEffect(() => {
        getPolygonsType();
    }, []);

    return (
        <FilterDropdown
            label={label}
            items={[
                { label: '', value: undefined },
                ...polygonsType.map((polygon) => {
                    return {
                        label: polygon.type,
                        value: polygon.type
                    };
                })
            ]}
            multiple={false}
            zIndex={zIndex}
            value={selectedPolygonsType}
            setValue={setSelectedPolygonsType}
            dropDownDirection={dropDownDirection ?? 'TOP'}
            placeholder={translate('map')}
            tooltipText={tooltipText}
            showTooltip={showTooltip}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
